/* eslint-disable @typescript-eslint/no-explicit-any */

export const pbjsPaapiConfig: any = {
    enabled: true,
    gpt: {
        autoconfig: false
    },
    defaultForSlots: 1,
    bidders: ['criteo', 'rtbhouse'],
};

//rtbhouse paapi conf teyitleşilecek
export const pbjsFledgeForGptConfig: any = {
    enabled: true,
    bidders: ['criteo', 'rtbhouse'],
    defaultForSlots: 1
};



export const pbjsConfig_Default: any = {
    criteo: {
        fastBidVersion: 'latest',
    },
    fledgeForGpt: pbjsFledgeForGptConfig,
    paapi: pbjsPaapiConfig,
    currency: {
        adServerCurrency: "TRY",
    },
    consentManagement: undefined,
    gvlMapping: null,
    priceGranularity: {
        "buckets": [
            {
                "precision": 2,
                "min": 0,
                "max": 10,
                "increment": 0.01
            },
            {
                "precision": 2,
                "min": 10,
                "max": 25,
                "increment": 0.05
            },
            {
                "precision": 2,
                "min": 25,
                "max": 50,
                "increment": 0.1
            },
            {
                "precision": 2,
                "min": 50,
                "max": 100,
                "increment": 0.25
            }]
    },
    userSync: {
        userIds: [
            {
                name: 'yandex',
                bidders: ['yandex'],
                storage: {
                    type: 'cookie',
                    name: '_ym_uid',
                    expires: 365,
                },
            },
            {
                name: "pubCommonId",
                storage: {
                    type: "cookie",
                    name: "_pubcid",
                    expires: 60
                }
            }],
        syncDelay: 3000 // 3 seconds after the first auction
    },

};

export const pbjsConfig_ConsentManagement: any = {
    gdpr: {
        cmpApi: 'iab',
        defaultGdprScope: true,
        allowAuctionWithoutConsent: true, //suppress auctions if there's no GDPR consent string
        timeout: 3000,
        rules: [{
            purpose: "storage",
            enforcePurpose: true,
            enforceVendor: true,
            vendorExceptions: ['yandex']
        }, {
            purpose: "basicAds",
            enforcePurpose: true,
            enforceVendor: true,
            vendorExceptions: ['yandex']
        }, {
            purpose: "measurement",
            enforcePurpose: true,
            enforceVendor: true,
            vendorExceptions: ['yandex']
        }, {
            purpose: "personalizedAds",
            enforcePurpose: true,
            enforceVendor: true,
            vendorExceptions: ['yandex']

        }]
    },
    usp: {
        cmpApi: 'iab',
        timeout: 1000
    }
} as any;

export const pbjsConfig_GvlMapping = {
    "yandex": 9855524
};

export const pbjs_BidderSettings = {
    taboola: {
        storageAllowed: true
    }
}


